import React from 'react';
import { Card, CardContent, Typography, Box, Stack } from '@mui/material';

const CardsModule = ({title1,title2,title3, total, activos, inactivos }) => {
  const cardsData = [
    {
      title: title1 || 'TOTAL',
      value: total,
      color: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
      icon: 'fas fa-users fa-3x',
      iconColor: 'rgba(255,255,255,0.2)'
    },
    {
      title: title2 || 'ACTIVOS',
      value: activos,
      color: 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)',
      icon: 'fas fa-check-circle fa-3x',
      iconColor: 'rgba(255,255,255,0.2)'
    },
    {
      title: title3 || 'INACTIVOS',
      value: inactivos,
      color: 'linear-gradient(135deg, #ff512f 0%, #dd2476 100%)',
      icon: 'fas fa-user-times fa-3x',
      iconColor: 'rgba(255,255,255,0.2)'
    }
  ];

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} mb={3}>
      {cardsData.map((card, index) => (
        <Card
          key={index}
          sx={{
            flex: 1,
            background: card.color,
            color: 'white',
            borderRadius: 4,
            boxShadow: 3,
            position: 'relative',
            overflow: 'hidden',
            '&:hover': {
              transform: 'translateY(-5px)',
              transition: '0.3s'
            }
          }}
        >
          <Box sx={{
            position: 'absolute',
            top: -20,
            right: -20,
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)'
          }}></Box>

          <CardContent sx={{ p: 3 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography
                  variant="overline"
                  sx={{
                    letterSpacing: 2,
                    fontWeight: 'bold',
                    opacity: 0.8
                  }}
                >
                  {card.title}
                </Typography>
                <Typography
                  variant="h3"
                  component="div"
                  sx={{ fontWeight: 800, mt: 1 }}
                >
                  {card.value}
                </Typography>
              </Box>
              <i
                className={card.icon}
                style={{ color: card.iconColor }}
              ></i>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default CardsModule;